var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import styles from "./text.module.css";
export var H1 = createText("h1");
export var H2 = createText("h2");
export var H3 = createText("h3");
export var H4 = createText("h4");
export var H5 = createText("h5");
export var H6 = createText("h6");
export var P = createText("p");
export var CommonText = forwardRef(function CommonText(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.el, el = _c === void 0 ? "div" : _c, _d = _a.type, type = _d === void 0 ? "default" : _d, children = _a.children, dangerous = _a.dangerous, color = _a.color, fontSize = _a.fontSize, fontWeight = _a.fontWeight, lineHeight = _a.lineHeight, letterSpacing = _a.letterSpacing, textAlign = _a.textAlign, textTransform = _a.textTransform, margin = _a.margin, padding = _a.padding, underline = _a.underline, bullet = _a.bullet, style = _a.style, rest = __rest(_a, ["className", "el", "type", "children", "dangerous", "color", "fontSize", "fontWeight", "lineHeight", "letterSpacing", "textAlign", "textTransform", "margin", "padding", "underline", "bullet", "style"]);
    var El = el;
    var isDangerous = dangerous && typeof children === "string";
    var props = __assign(__assign({}, rest), { className: classNames(styles["container"], styles[type], className, (_b = {},
            _b[styles["has-underline"]] = !!underline,
            _b[styles["underline".concat(underline === true || underline === "sm" ? "" : "-".concat(underline))]] = !!underline,
            _b[styles["has-bullet"]] = !!bullet,
            _b[styles["bullet".concat(bullet === true || bullet === "sm" ? "" : "-".concat(bullet))]] = !!bullet,
            _b)) });
    var textStyle = __assign({ color: color, fontSize: fontSize, fontWeight: fontWeight, lineHeight: lineHeight, letterSpacing: letterSpacing, textAlign: textAlign, textTransform: textTransform, margin: margin, padding: padding }, style);
    return isDangerous ? (_jsx(El, __assign({}, props, { dangerouslySetInnerHTML: {
            __html: children,
        }, style: textStyle, ref: ref }))) : (_jsx(El, __assign({}, props, { style: textStyle, ref: ref, children: children })));
});
export function createText(el) {
    return forwardRef(function (props, ref) {
        return _jsx(CommonText, __assign({ el: el, type: el }, props, { ref: ref }));
    });
}
